import styled from '@emotion/styled';
import { padding } from 'polished';

export const Row = styled('div')(
  ({ justifyContent = 'flex-start', flexDirection = 'row', theme }) => ({
    display: 'flex',
    flexDirection,
    alignItems: 'center',
    ...padding(theme.spacing.small, 0),
    justifyContent
  })
);

export const ButtonContainer = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  alignItems: 'center',
  flexGrow: 1
});

export const ButtonLabel = styled('span')(({ theme }) => ({
  whiteSpace: 'nowrap',
  ...padding(0, theme.spacing.tiny)
}));

export const Subtitle = styled.h4({
  textAlign: 'center'
});
